import {forwardRef} from 'react';

import {omit} from 'es-toolkit';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, Ref} from './types';

import {Clickable} from '../Clickable';
import {CountryFlag} from '../CountryFlag';
import {useController} from './controller';
import * as S from './styles';

export const PhoneInput = forwardRef<Ref, WithDomStyleProp<Props>>(
  (props, ref) => {
    const {error, ...rest} = omit(props, [
      'onSelectCountryClick',
      'onPhoneChange',
      'defaultValue',
      'containerStyle',
    ]);

    const {country, formattedNumber, onChange, onSelectCountryClick} =
      useController(props);

    return (
      <S.Container className={rest.className} error={error} style={rest.style}>
        <Clickable onClick={onSelectCountryClick}>
          <S.FlagWrapper>
            <S.FlagContainer>
              <CountryFlag countryCode={country.iso2} />
            </S.FlagContainer>
            <S.DialCode>{`+${country.dialCode}`}</S.DialCode>
          </S.FlagWrapper>
        </Clickable>
        <S.Input
          ref={ref}
          {...omit(rest, ['style', 'className'])}
          inputMode="tel"
          onChange={onChange}
          placeholder={props.placeholder ?? ''}
          value={formattedNumber}
        />
      </S.Container>
    );
  },
);
